import IRepositoryWrapper from "./IRepositoryWrapper";
import { singleton } from "tsyringe";
import AuthenticateRepository from "../Authenticate/AuthenticateRepository";
import IAuthenticateRepository from "../Authenticate/IAuthenticateRepository";
import { environment } from "../../../environment/environment";
import IBaseDataRepository from "../BaseData/IBaseDataRepository";
import BaseDataRepository from "../BaseData/BaseDataRepository";
import StandardsRepository from "../Standards/StandardsRepository";
import ProjectsRepository from "../Projects/ProjectsRepository";
import IStandardsRepository from "../Standards/IStandardsRepository";
import IProjectsRepository from "../Projects/IProjectsRepository";


@singleton()
// @ts-ignore
export default class RepositoryWrapper implements IRepositoryWrapper {
  private baseUrl = environment.baseUrl;
  private defaultHeaders: any = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  Authenticate: IAuthenticateRepository;
  Projects: IProjectsRepository;
  BaseData: IBaseDataRepository;
  Standards: IStandardsRepository;


  constructor() {
    this.Authenticate = new AuthenticateRepository(this.baseUrl, this.defaultHeaders, "Authenticate");
    this.Projects = new ProjectsRepository(this.baseUrl, this.defaultHeaders, "Projects");
    this.Standards = new StandardsRepository(this.baseUrl, this.defaultHeaders, "Standards");
    this.BaseData = new BaseDataRepository(this.baseUrl, this.defaultHeaders, "BaseData");
  }

  SetValueToHeader(key: string, value: string) {
    this.defaultHeaders[key] = value;
  }
}
